import { useLayoutContext } from "@context/layout";
import { FC, useMemo } from "react";
import {
  BannerSource,
  getAvailableSources,
  getImageOrigin,
  preloadMediaFor,
} from "./helpers";
import Head from "next/head";

const FestivalBannerPreload: FC<{ disabled?: boolean }> = ({
  disabled = false,
}) => {
  const { fetstivalBanner } = useLayoutContext();
  const banner =
    !disabled && fetstivalBanner?.is_active ? fetstivalBanner.banner : null;

  const { sources, origin } = useMemo(() => {
    if (!banner) return { sources: [] as BannerSource[], origin: "" };
    const nextSources = getAvailableSources(banner);
    return {
      sources: nextSources,
      origin: getImageOrigin(nextSources[0]?.srcSet || ""),
    };
  }, [banner]);

  if (!sources.length) return null;

  return (
    <Head>
      {origin ? <link rel="preconnect" href={origin} /> : null}
      {sources.map((source, index) => (
        <link
          key={source.srcSet}
          rel="preload"
          as="image"
          href={source.srcSet}
          type={source.type}
          media={preloadMediaFor(sources, index)}
          {...{ fetchpriority: "high" }}
        />
      ))}
    </Head>
  );
};

export default FestivalBannerPreload;
